import axios from 'axios';
import { getAPIErrorReason } from '../helpers/common';
import { REACT_APP_TEAMCAMP_APIURL } from '../global/environment';
import { captureException } from './logService';
import { rootStore } from '../mobx/rootStore';

export const getSnapListByUser = async () => {
  try {
    const response = await axios.get(`${REACT_APP_TEAMCAMP_APIURL}/share/getSnapByUser`);
    const { data } = response;
    if (response) {
      rootStore.appStore.setSnapList(data);
    }
  } catch (e) {
    const error = getAPIErrorReason(e) || 'Unable to get snap list please try again';
    captureException(error);
    dispatchSnapError(error);
  }
};

export const deleteSnap = async (snapId: string) => {
  try {
    const response = await axios.delete(`${REACT_APP_TEAMCAMP_APIURL}/share/deleteShare/${snapId}`);
    if (response) {
      return true;
    }
    return false;
  } catch (e) {
    const error = getAPIErrorReason(e) || 'Unable to delete snap please try again';
    captureException(error);
    dispatchSnapError(error);
  }
};

export const renameSnap = async (snapId: string, payload: { Name: string }) => {
  try {
    const response = await axios.put(`${REACT_APP_TEAMCAMP_APIURL}/share/updateShare/${snapId}`, payload);
    if (response) {
      return true;
    }
    return false;
  } catch (e) {
    const error = getAPIErrorReason(e) || 'Unable to update snap data please try again';
    captureException(error);
    dispatchSnapError(error);
  }
};

function dispatchSnapError(msg: string) {
  rootStore.alertNotificationStore.setErrorMessage(msg);
}

export function dispatchSnapSuccess(msg: string) {
  rootStore.alertNotificationStore.setSuccessMessage(msg);
}
